import * as types from '../../action-types';
import { getBrokerMetrics as initialState } from "../../initialState";

const getBrokerMetrics = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_BROKER_METRICS_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_BROKER_METRICS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_BROKER_METRICS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_BROKER_METRICS_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getBrokerMetrics;
